/** "1:05.5", "65.5" or "1:02:03" to seconds; NaN when it is not a time. */
export const parseTime = (text: string): number => {
  const parts = text.trim().split(":");
  if (parts.length === 0 || parts.length > 3 || parts.some((x) => x === "" || isNaN(Number(x)))) return NaN;
  return parts.reduce((acc, x) => acc * 60 + Number(x), 0);
};

/** Seconds as m:ss.s, or h:mm:ss.s past an hour. */
export const formatTime = (t: number): string => {
  const h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = (t % 60).toFixed(1).padStart(4, "0");
  return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${s}` : `${m}:${s}`;
};
